import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { isTokenExpired, isAdminNotConsultant } from "@/js/http/auth.js";
export default {
  name: "Footer",
  props: {
    isTerms: Boolean,
    forceDark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLinkContactShown: function isLinkContactShown() {
      return isTokenExpired() || !isTokenExpired() && !isAdminNotConsultant();
    },
    isLogged: function isLogged() {
      return !isTokenExpired();
    }
  },
  components: {
    ScrollToTop: function ScrollToTop() {
      return import("./ScrollToTop.vue");
    },
    TokenExpirationModal: function TokenExpirationModal() {
      return import("../modal/TokenExpirationModal.vue");
    }
  },
  methods: {
    goToTermsOfUse: function goToTermsOfUse() {
      return {
        name: !isTokenExpired() ? "userTermsOfUse" : "termsOfUse"
      };
    },
    goToTermsOfSales: function goToTermsOfSales() {
      var anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return {
        name: !isTokenExpired() ? "userTermsOfSales" : "termsOfSales",
        hash: anchor
      };
    },
    goToContact: function goToContact() {
      return {
        name: !isTokenExpired() ? "userContact" : "contact"
      };
    },
    handleAnchorClick: function handleAnchorClick(anchor) {
      this.$nextTick(function () {
        if (anchor) {
          var el = document.getElementById(anchor);
          if (el) {
            el.scrollIntoView({
              behavior: "smooth"
            });
          }
        } else {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }
      });
    }
  }
};